import { render, staticRenderFns } from "./icon-edit.vue?vue&type=template&id=37d1aa10&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d1aa10')) {
      api.createRecord('37d1aa10', component.options)
    } else {
      api.reload('37d1aa10', component.options)
    }
    module.hot.accept("./icon-edit.vue?vue&type=template&id=37d1aa10&", function () {
      api.rerender('37d1aa10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/icons/icon-edit.vue"
export default component.exports